export const GanttColors = {
  // Connection circle (drag source)
  CONNECTION_CIRCLE: '#666666',

  // Drop target circle
  DROP_TARGET: '#4CAF50',

  // Dependency line
  DEPENDENCY_LINE: '#666666',

  // Critical path
  CRITICAL_PATH_LINE: '#FF0000',
  CRITICAL_PATH_CIRCLE: '#FF0000',
} as const

/**
 * Preset colors for link (dependency / critical path) color selection
 */
export const LINK_COLOR_PRESETS = [
  '#000000',
  '#FF0000',
  '#1976d2',
  '#ed6c02',
  '#ffc107',
  '#2e7d32',
  '#9c27b0',
] as const

/**
 * Dimension constants for Gantt chart dependency / critical path rendering
 */
export const GanttDimensions = {
  // Connection circle (drag source for dependency)
  CONNECTION_CIRCLE_SIZE: 15,
  CONNECTION_CIRCLE_OFFSET: 8,

  // Drop target circle (larger than connection circle)
  DROP_TARGET_CIRCLE_SIZE: 20,

  // Dependency line
  DEPENDENCY_LINE_WIDTH: 1.5,

  // Critical path
  CRITICAL_PATH_LINE_WIDTH: 2,
  CRITICAL_PATH_CIRCLE_RADIUS: 4,
} as const
